var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextcolorchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73408 14.8126C5.30302 14.8126 4.95426 14.6911 4.68779 14.4482C4.42132 14.2052 4.28809 13.8604 4.28809 13.4136C4.28809 13.3118 4.29592 13.206 4.3116 13.0962C4.32727 12.9865 4.35078 12.8689 4.38213 12.7435L7.86192 1.8457C8.01867 1.30492 8.2969 0.86211 8.6966 0.517266C9.09631 0.172422 9.55087 0 10.0603 0H11.1419C11.6591 0 12.1137 0.172422 12.5056 0.517266C12.9053 0.86211 13.1835 1.30492 13.3402 1.8457L16.82 12.7435C16.8592 12.8689 16.8866 12.9865 16.9023 13.0962C16.918 13.206 16.9258 13.3118 16.9258 13.4136C16.9258 13.8604 16.7926 14.2052 16.5261 14.4482C16.2597 14.6911 15.907 14.8126 15.4681 14.8126C14.9273 14.8126 14.5276 14.6755 14.269 14.4011C14.0103 14.1268 13.8144 13.7115 13.6812 13.155L13.0228 11.1095H8.19109L7.53275 13.155C7.39952 13.7115 7.19967 14.1268 6.9332 14.4011C6.67456 14.6755 6.27486 14.8126 5.73408 14.8126ZM8.75538 8.77001H12.4585L10.8009 3.09184C10.7617 2.94293 10.7265 2.80186 10.6951 2.66862C10.6638 2.52755 10.6324 2.40215 10.6011 2.29243C10.5776 2.40215 10.5501 2.52755 10.5188 2.66862C10.4874 2.80186 10.4522 2.94293 10.413 3.09184L8.75538 8.77001Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.11568,
    y: 17.0771,
    width: 18.9822,
    height: 4.13243,
    rx: 2.06622,
    fill: "url(#paint0_linear_7626_26125)",
    stroke: "#EAEAEA",
    strokeWidth: 0.42
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7626_26125",
    x1: 1.32568,
    y1: 19.1433,
    x2: 19.8879,
    y2: 19.1433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282913,
    stopColor: "#FAF900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563417,
    stopColor: "#65FE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765029,
    stopColor: "#00DFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextcolorchange);
export default __webpack_public_path__ + "static/media/textcolorchange.dd8aa4fd1f041c3f6a6649871e3f8b8c.svg";
export { ForwardRef as ReactComponent };